var map = {
	"./1right-n.png": "wqLM",
	"./2right-n.png": "9CQ1",
	"./3right-n.png": "iRUY",
	"./4right-n.png": "eiPh",
	"./5right-n.png": "BWvx",
	"./6right-n.png": "WTXU",
	"./7right-n.png": "VmZt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6LrU";